import React from 'react';
import PropTypes from 'prop-types';
import './errorPage.css';

export default function ErrorPage({ error }) {
  return (
    <div className="tpx-error-tmp">
      {error.name ? <p>Error Type: {error.name}</p> : null}
      <p>Message: {error.message}</p>
      {error.code ? <p>Error Code: {error.code}</p> : null}
    </div>
  );
}

ErrorPage.propTypes = {
  error: PropTypes.object.isRequired,
};
